import { ColumnInfo, ColumnInfoList, DisplaySetting } from 'components/shared/display_setting'
import { Flex } from 'components/shared/flex'
import { TableCell } from 'components/shared/widget'
import { ProductItem, ProductItemSearchForm } from 'entities/product_item'
import { ReactNode, useMemo } from 'react'
import { Form } from 'utils/hooks'
import { ProtocolVersionViewModel } from 'view_models/protocol_version_view_model'
// import { ProductItemViewModel } from 'view_models/product_item_view_model'

export const productItemColumnInfoList = (form?: Form<ProductItemSearchForm>): ColumnInfoList => {
    let values: ColumnInfo[] = [
        { name: 'ID', th: true, width: 40, align: 'center', form: form, orderAttr: 'product_item_id', searchType: { name: 'id', type: 'multiple_text' } },
        { name: '名称', th: true, minWidth: 120, form: form, orderAttr: 'product_item_code', searchType: { name: 'code', type: 'text' } },
        {
            name: '最新',
            align: 'center',
            th: true,
            width: 60,
        },
        {
            name: '現在',
            align: 'center',
            th: true,
            width: 60,
        },
        { name: 'Probe数', th: true, width: 100, align: 'center' },
    ]

    if (form?.object.scope !== 'only_qc') {
        values = values.concat([
            {
                name: 'QC',
                align: 'center',
                th: true,
                width: 60,
            },

            { name: 'QC Probe数', th: true, width: 100, align: 'center' },
        ])
    } else {
        values = values.concat([
            {
                name: 'タイプ',
                th: true,
                width: 120,
            },
        ])
    }
    return {
        tableName: '',
        values: values,
    }
}

export type ProductItemTableDataProps = {
    productItem?: ProductItem
    displaySetting: DisplaySetting
    onClickProbe: () => void
    onClickQcProbe: () => void
}

export const ProductItemTableData = ({ productItem, displaySetting, onClickProbe, onClickQcProbe }: ProductItemTableDataProps): JSX.Element => {
    if (!productItem) {
        return (
            <>
                {displaySetting.columnInfoList.values.map((_: ColumnInfo, index: number) => {
                    if (displaySetting.hiddenList.includes(index)) {
                        return <></>
                    } else {
                        return <TableCell key={index}></TableCell>
                    }
                })}
            </>
        )
    }
    // const vm = new ProductItemViewModel(productItem)

    const createCells = useMemo(() => {
        return (
            <>
                <TableCell align="center">{productItem.id}</TableCell>
                <TableCell>
                    <Flex alignItems="center">
                        <div style={{ width: 8, height: 30, backgroundColor: productItem.color }}></div>
                        <div>{productItem.name}</div>
                    </Flex>
                </TableCell>
                <TableCell align="center">
                    {new ProtocolVersionViewModel(
                        productItem.protocolversionSet ? productItem.protocolversionSet[productItem.protocolversionSet.length - 1] : {}
                    ).versionView()}
                </TableCell>
                <TableCell align="center">{new ProtocolVersionViewModel(productItem.currentProtocolVersion!).versionView()}</TableCell>
                <TableCell align="center">
                    <div className="linked-text" onClick={() => onClickProbe()}>
                        {productItem.currentProtocolVersion?.probes?.length} probes
                    </div>
                </TableCell>

                {(productItem.isStandardQc || productItem.isRnaStandardQc) && (
                    <TableCell>
                        <div>{productItem.nameEn}</div>
                    </TableCell>
                )}
                {!productItem.isStandardQc && !productItem.isRnaStandardQc && (
                    <>
                        <TableCell align="center">{new ProtocolVersionViewModel(productItem.qcVersion!).versionView()}</TableCell>
                        <TableCell align="center">
                            <div className="linked-text" onClick={() => onClickQcProbe()}>
                                {productItem.qcVersion?.probes?.length} probes
                            </div>
                        </TableCell>
                    </>
                )}
            </>
        )
    }, [displaySetting.hiddenList])

    return createCells.props.children.filter((_: ReactNode, index: number) => !displaySetting.hiddenList?.includes(index)).map((cell: ReactNode) => cell)
}
